'use client';

import Image from 'next/image';
import NewsCard from '../../../components/blog/newsCard';
import imgAdv from '@/assets/images/buy-now.jpg';
import { MagnifyingGlassIcon, PlusCircleIcon } from '@heroicons/react/24/solid';
import SideArticle from '../../../components/blog/sideArticle';
import { GetNews } from '@/services/auth.api';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addToNews } from '@/redux/slices/news.slice';
import { BarLoader } from 'react-spinners';
import PageContainer from '@/components/global/page-container';
import RecentPosts, { InstagramPost } from '@/components/blog/recentPostCard';
import { fetchInstagramPosts } from '@/services/instagram.api';

function News() {
  const [news, setNews] = useState<any[]>();
  const [instagramPosts, setInstagramPosts] = useState<InstagramPost[]>([]);
  const [sortedNews, setSortedNews] = useState<any[]>();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const getNews = async () => {
    try {
      setLoading(true);
      const res = await GetNews();

      setNews(res);
      dispatch(addToNews(res));

      const sortedData = res.slice().sort(function (a: any, b: any) {
        return (
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      });

      setSortedNews(sortedData);
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  const getPosts = async () => {
    try {
      setLoading(true);
      const res = await fetchInstagramPosts();

      setInstagramPosts(res.data);
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNews();
    getPosts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="h-screen w-screen flex justify-center items-center animate-pulse">
        <BarLoader color="#ca1611" />
      </div>
    );
  }

  return (
    <PageContainer
      pageTitle="Our Blog"
      pageDesc="Our Crunchy Treat is the talk of the town"
    >
      <section className="p-4 bg-gray-100 flex flex-col lg:flex-row gap-10">
        <ul className="flex flex-col lg:flex-row lg:w-[70%]">
          <li className="grid md:grid-cols-2 gap-5 lg:px-10 auto-rows-fr">
            {sortedNews?.map((item: any, index) => (
              <div className="w-full h-full hover:cursor-pointer " key={index}>
                <NewsCard key={item._id} item={item} />
              </div>
            ))}
          </li>
        </ul>
        <aside className="w-full lg:w-[30%] ">
          {instagramPosts.length !== 0 ? (
            <>
              <RecentPosts posts={instagramPosts} />
              <div className="mt-5">
                <Image
                  src={imgAdv.src}
                  alt="banner"
                  width={300}
                  height={100}
                  className=" object-cover object-center "
                />
              </div>
            </>
          ) : (
            ''
          )}
        </aside>
      </section>
    </PageContainer>
  );
}

export default News;
